import 'isomorphic-fetch';
import { MaintenanceSchedule } from '../typings/general';

interface FetchMaintenanceScheduleOptions {
  readonly faServicesUrl: string;
  readonly apiKey: string;
  readonly modelYear?: string;
  readonly salesModelCode?: string;
  readonly vin?: string;
  readonly odometerValue?: number;
}

function createMaintenanceScheduleUrl(
  params: URLSearchParams,
  urlOrigin: string,
): string {
  return `${urlOrigin}/maintenance/schedule?${params.toString()}`;
}

export async function fetchMaintenanceSchedule({
  faServicesUrl,
  apiKey,
  modelYear,
  salesModelCode,
  vin,
  odometerValue = 0,
}: FetchMaintenanceScheduleOptions): Promise<MaintenanceSchedule> {
  const params = new URLSearchParams();

  params.set('brand', 'V');
  params.set('importerCode', '444');
  params.set('languageCode', 'en-US');
  params.set('odometerValue', String(odometerValue));
  params.set('odometerUnit', 'MI');

  if (vin) params.set('vin', vin);

  if (modelYear) params.set('modelYear', modelYear);

  if (salesModelCode) params.set('salesModelCode', salesModelCode);

  const response = await fetch(
    createMaintenanceScheduleUrl(params, faServicesUrl),
    {
      headers: { 'x-api-key': apiKey },
    },
  );
  const maintenanceSchedule = await response.json();

  if (response.status >= 400) throw new Error(maintenanceSchedule.message);

  return maintenanceSchedule;
}
